import React, {useEffect, useRef, useState} from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Link} from 'react-router-dom';
import clsx from 'clsx';

import './Frame.scss';
import LeftMenu from '../LeftMenu/LeftMenu';
import logo from '../../Pics/logo-cst.png'
import ueLogo from '../../Pics/logo-ue.png'

const Frame = ({ is_logged, isToppAppBarFocused, isMenuFocused }) => {
	const isMobile = useMediaQuery('(max-width: 992px)');
	const [overlayShow, setOverlayShow] = useState(() => {
		if (typeof window !== 'undefined') {
			return !window.matchMedia('(max-width: 992px)').matches;
		}
		return true;
		});
	const [isSubmenuOpened, setIsSubmenuOpened] = useState(false);
	const menuRef = useRef();
	const firstRender = useRef(true);

	useEffect(() => {
		const menu = menuRef.current;
		if (menu && isMenuFocused) {
			menu.focus();
		}
	}, [isMenuFocused]);

	useEffect(() => {
		if (overlayShow && menuRef.current && !firstRender.current) {
			menuRef.current.focus();
		}
		firstRender.current = false;
	}, [overlayShow]);

	useEffect(() => {
		if (!isMobile) {
			document.body.classList.toggle('left-menu-open', overlayShow);
		} else {
			document.body.classList.remove('left-menu-open');
		}
	}, [overlayShow, isMobile]);


	const maniNavClassName = clsx([
		'main-nav-container',
		overlayShow && 'main-nav-container--open',
		isSubmenuOpened && 'main-nav-container--with-submenu',
	]);

	const setIsUnfold = (data) => setIsSubmenuOpened(data);

	return (
		<div id='container'>
			<header
				id='top_bar'
				className={clsx(
					'top-app-bar',
					overlayShow && !isMobile && 'top-app-bar--shifted'
				)}
				>
				<div className="top-app-bar__menu">
					{is_logged ? (
						<button
							data-v-251a9832=''
							id='nav-button'
							type='button'
							onClick={() => setOverlayShow(prev => !prev)}
							className='v-toolbar__side-icon v-btn v-btn--icon theme--dark white nav-button'
							aria-label={overlayShow ? 'Ukryj menu' : 'Pokaż menu'}
							aria-expanded={overlayShow}
						>
							<div className='v-btn__content'>
								<i data-v-251a9832='' aria-hidden='true' className='v-icon material-icons theme--dark'>menu</i>
							</div>
						</button>) : null}
					<h1 id='app_title' className={isMobile ? 'app-title' : 'sr-only white'}>
						{isMobile ? <Link className="home-page-link" to="/">e-Kontrole<span className="sr-only white"> - powrót na stronę główną</span></Link> : 'e-Kontrole'}
					</h1>
				</div>
				{/* <LoginInfo /> */}
			</header>

			<div id='left_bar' className={maniNavClassName} tabIndex="-1">
				<div id='logo'><Link to="/" ref={menuRef}><span
					className="sr-only on-bg-text">Powrót na stronę główną</span><img src={logo} alt='logo cst'/></Link>
				</div>
				<LeftMenu isSubmenuOpened={setIsUnfold}/>
				<div className="mb-4 text-center">
					<img src={ueLogo} alt='Zestawienie znaków: Fundusze Europejskie, Barwy Rzeczypospolitej Polskiej, Unia Europejska'/>
				</div>
			</div>

			{overlayShow && isMobile ? <div id='v-overlay' onClick={() => setOverlayShow(prev => !prev)}/> : null}

		</div>
	);
};

export default Frame;